export const RegisterSteps = {
    SelectFlow: 'SelectFlow',
    SelectProduct: 'SelectProduct',
    SelectSupplier: 'SelectSupplier',
    SelectAddress: 'SelectAddress',
    Finish: 'Finish',
}

export const BaseSteps = [
    {
        id: 0,
        step: RegisterSteps.SelectFlow,
        title: "Tipo da solicitação",
        sequence: 0,
    },
    {
        id: 1,
        step: RegisterSteps.SelectProduct,
        title: "Informações do produto/serviço",
        sequence: 1,
    },
    {
        id: 2,
        step: RegisterSteps.SelectSupplier,
        title: "Seleção do fornecedor",
        sequence: 2,
    },
    {
        id: 3,
        step: RegisterSteps.SelectAddress,
        title: "Entrega e faturamento",
        sequence: 3,
    },
    {
        id: 4,
        step: RegisterSteps.Finish,
        title: "Resumo da solicitação",
        sequence: 4,
    }
];